export enum PreviewAccountMetaPart {
  BAR = 'BAR',
  SQUARE = 'SQUARE',
}

export const PREVIEW_ACCOUNT_META_BAR_AND_SQUARE: PreviewAccountMetaPart[] = [PreviewAccountMetaPart.BAR, PreviewAccountMetaPart.SQUARE];

export const PREVIEW_ACCOUNT_META_BAR_ONLY: PreviewAccountMetaPart[] = [PreviewAccountMetaPart.BAR];

export const PREVIEW_ACCOUNT_META_SQUARE_ONLY: PreviewAccountMetaPart[] = [PreviewAccountMetaPart.SQUARE];

export const PREVIEW_ACCOUNT_META_BAR_WIDTH = 49;

export const PREVIEW_ACCOUNT_META_PART_HEIGHT = 8;

export const PREVIEW_ACCOUNT_META_SQUARE_WIDTH = PREVIEW_ACCOUNT_META_PART_HEIGHT;

export const PREVIEW_ACCOUNT_META_PART_RADIUS = '2px';

export interface PreviewAccountMetaSkeletonProps {
  parts: PreviewAccountMetaPart[];
}
